var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.loading,"decoding":_vm.decoding,"width":_vm.width,"height":_vm.height},on:{"load":_vm.onLoad}},'img',_vm.imageAttrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }